import { Box, Typography } from "@mui/material";
import { Telegram } from "@mui/icons-material";
import BasicButton from "v2/components/Buttons/BasicButton";

export const LoginCheckBlocker = () => {
  const handleLogin = () => {
    const referralId = window.localStorage.getItem("referralId");
    const botName = process.env.REACT_APP_TG_BOT_NAME!;
    window.open(`https://t.me/${botName}?start=login-${referralId}`, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "16px",
        textAlign: "center",
        gap: "8px",
      }}>
      <Box sx={{ padding: "12px" }}>
        <img src="/logo192.png" alt="cabal-town-logo" height="44px" />
      </Box>
      <Typography sx={{ marginBottom: "10px" }} variant="mobile-h2">
        CABAL.TOWN
      </Typography>
      <Typography
        sx={{ marginBottom: "12px", maxWidth: "250px" }}
        variant="mobile-body-m"
        color="text.secondary">
        Shill. Trade. Earn
      </Typography>
      <Box
        id="telegram-login-container"
        sx={{
          position: "relative",
          marginX: "auto",
          height: "56px",
          maxWidth: "300px",
          width: "100%",
          // paddingX: "12px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
        }}>
        <BasicButton variant="primary" sx={{ width: "100%", gap: "8px" }} onClick={handleLogin}>
          <Telegram />
          <Typography variant="mobile-action-s-heavy">Login</Typography>
        </BasicButton>
      </Box>
    </Box>
  );
};
